import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-415feade"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"700px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_3 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "com-wrap-box" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_form, {
        "label-position": "right",
        "label-width": "150px",
        ref: "form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "充值类型" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_form_item, {
                label: "名称",
                data: _ctx.formData.name,
                required: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                    placeholder: "请输入名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, { label: "描述" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.description,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.description) = $event)),
                    placeholder: "请输入描述"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, {
                label: "购买价格",
                data: _ctx.formData.price,
                required: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.price,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.price) = $event)),
                    placeholder: "请输入购买价格"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, {
                label: "获得金额",
                data: _ctx.formData.amount,
                required: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.amount,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.amount) = $event)),
                    placeholder: "请输入获得金额"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, { label: "奖励列表" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_ui_table, {
                      data: _ctx.formData.presentList
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, { label: "类型" }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_select, {
                              modelValue: row.type,
                              "onUpdate:modelValue": ($event: any) => ((row.type) = $event),
                              placeholder: "类型"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "优惠券",
                                  value: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "名称" }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_input, {
                              modelValue: row.name,
                              "onUpdate:modelValue": ($event: any) => ((row.name) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "描述" }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_input, {
                              modelValue: row.description,
                              "onUpdate:modelValue": ($event: any) => ((row.description) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "获得" }, {
                          default: _withCtx(({ row, $index }) => [
                            _createVNode(_component_el_link, {
                              onClick: ($event: any) => (_ctx.chooseData($index)),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.couponInfo ? row.couponInfo.name : "请选择优惠券"), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "数量" }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_input, {
                              modelValue: row.count,
                              "onUpdate:modelValue": ($event: any) => ((row.count) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "删除" }, {
                          default: _withCtx(({ row, $index }) => [
                            _createVNode(_component_ui_button, {
                              onClick: ($event: any) => (_ctx.formData.presentList.splice($index, 1))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("删除")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    _createVNode(_component_ui_button, {
                      style: {"margin-top":"10px"},
                      onClick: _ctx.addRow
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("添加记录")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ])
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }))
}